module.exports = __webpack_public_path__ + "static/media/arrow-square-left.d893b1be.svg";